(function () {
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-header-nav]");
  if (menuToggle && nav) {
    menuToggle.addEventListener("click", function () {
      const open = nav.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  document.querySelectorAll("[data-compare-carousel]").forEach(function (root) {
    const slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
    const dots = Array.prototype.slice.call(root.querySelectorAll("[data-slide-dot]"));
    if (slides.length < 2) return;

    let index = 0;
    let touchX = 0;
    let touchY = 0;

    function go(next) {
      next = (next + slides.length) % slides.length;
      index = next;
      root.style.setProperty("--compare-index", String(index));
      slides.forEach(function (slide, i) {
        const active = i === index;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
        if (active) {
          slide.removeAttribute("inert");
        } else {
          slide.setAttribute("inert", "");
        }
      });
      dots.forEach(function (dot, i) {
        const active = i === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-selected", active ? "true" : "false");
      });
    }

    root.style.setProperty("--compare-index", "0");

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        go(i);
      });
    });

    root.addEventListener("touchstart", function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      touchX = event.changedTouches[0].clientX;
      touchY = event.changedTouches[0].clientY;
    }, { passive: true });

    root.addEventListener("touchend", function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      const dx = event.changedTouches[0].clientX - touchX;
      const dy = event.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      go(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
  });

  document.querySelectorAll("[data-tabs]").forEach(function (root) {
    const tabs = Array.prototype.slice.call(root.querySelectorAll("[data-tab]"));
    const panels = Array.prototype.slice.call(root.querySelectorAll("[data-tab-panel]"));
    if (!tabs.length || !panels.length) return;

    function show(id) {
      tabs.forEach(function (tab) {
        const on = tab.getAttribute("data-tab") === id;
        tab.setAttribute("aria-pressed", on ? "true" : "false");
        tab.classList.toggle("btn--outline-cyan", on);
        tab.classList.toggle("btn--white", !on);
      });
      panels.forEach(function (panel) {
        const on = panel.getAttribute("data-tab-panel") === id;
        panel.hidden = !on;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function (event) {
        event.preventDefault();
        show(tab.getAttribute("data-tab"));
        const carousel = root.querySelector("[data-card-carousel]");
        if (carousel && typeof carousel._resetCarousel === "function") {
          carousel._resetCarousel();
        }
      });
    });
  });

  document.querySelectorAll("[data-card-carousel]").forEach(function (root) {
    const viewport = root.querySelector("[data-carousel-viewport]");
    const dots = Array.prototype.slice.call(root.querySelectorAll("[data-carousel-dot]"));
    if (!viewport || dots.length < 2) return;

    let index = 0;

    function activeTrack() {
      return root.querySelector("[data-carousel-track]:not([hidden])") || root.querySelector("[data-carousel-track]");
    }

    function maxScroll() {
      const track = activeTrack();
      if (!track) return 0;
      return Math.max(0, track.scrollWidth - viewport.clientWidth);
    }

    function setDots(next) {
      index = next;
      dots.forEach(function (dot, i) {
        const on = i === next;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
      });
    }

    function go(next) {
      const pages = dots.length;
      next = Math.max(0, Math.min(next, pages - 1));
      const max = maxScroll();
      const x = pages <= 1 || max < 1 ? 0 : (next / (pages - 1)) * max;
      viewport.scrollTo({ left: x, behavior: "smooth" });
      setDots(next);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        go(i);
      });
    });

    viewport.addEventListener("scroll", function () {
      const max = maxScroll();
      if (max < 1) {
        setDots(0);
        return;
      }
      const ratio = viewport.scrollLeft / max;
      setDots(ratio < 0.5 ? 0 : dots.length - 1);
    }, { passive: true });

    root._resetCarousel = function () {
      viewport.scrollTo({ left: 0, behavior: "auto" });
      setDots(0);
    };
  });

  document.querySelectorAll("[data-quiz]").forEach(function (quiz) {
    const radioOn = quiz.getAttribute("data-radio-on");
    const radioOff = quiz.getAttribute("data-radio-off");
    const steps = Array.prototype.slice.call(quiz.querySelectorAll("[data-quiz-step]"));
    const next = quiz.querySelector("[data-quiz-next]");
    const back = quiz.querySelector("[data-quiz-back]");
    const progress = quiz.querySelector("[data-quiz-progress]");
    const results = {
      fit: quiz.querySelector('[data-quiz-result="fit"]'),
      maybe: quiz.querySelector('[data-quiz-result="maybe"]'),
      "not-yet": quiz.querySelector('[data-quiz-result="not-yet"]'),
      tbd: quiz.querySelector('[data-quiz-result="tbd"]')
    };
    let stepIndex = 0;
    const answers = [];
    const nextLabel = quiz.getAttribute("data-next-label") || "NEXT QUESTION";
    const finishLabel = quiz.getAttribute("data-finish-label") || "FINISH";

    function currentStep() {
      return steps[stepIndex];
    }

    function setProgress() {
      if (!progress) return;
      progress.style.width = ((stepIndex + 1) / Math.max(steps.length, 1) * 100) + "%";
    }

    function updateButton() {
      if (!next) return;
      next.textContent = stepIndex >= steps.length - 1 ? finishLabel : nextLabel;
    }

    function updateBack() {
      if (!back) return;
      back.hidden = stepIndex === 0 && !quiz.classList.contains("is-complete");
    }

    function showStep(index) {
      steps.forEach(function (step, i) {
        step.hidden = i !== index;
      });
      stepIndex = index;
      setProgress();
      updateButton();
      updateBack();
    }

    function clearResults() {
      quiz.classList.remove("is-complete");
      Object.keys(results).forEach(function (name) {
        if (results[name]) results[name].hidden = true;
      });
    }

    function bindOptions(step) {
      const options = step.querySelectorAll("[data-quiz-option]");
      options.forEach(function (option) {
        option.addEventListener("click", function () {
          options.forEach(function (el) {
            el.classList.remove("is-selected");
            const icon = el.querySelector("img");
            if (icon && radioOff) icon.src = radioOff;
          });
          option.classList.add("is-selected");
          const icon = option.querySelector("img");
          if (icon && radioOn) icon.src = radioOn;
          answers[stepIndex] = option.getAttribute("data-value");
          if (answers[stepIndex] === "no") {
            finish("tbd");
          }
        });
      });
    }

    steps.forEach(bindOptions);
    setProgress();
    updateButton();
    updateBack();

    function resultKey() {
      if (answers[2] !== "yes") return "not-yet";
      if (answers[0] !== "yes" || answers[1] !== "yes") return "maybe";
      return "fit";
    }

    function finish(key) {
      quiz.classList.add("is-complete");
      Object.keys(results).forEach(function (name) {
        if (results[name]) results[name].hidden = name !== key;
      });
      updateBack();
    }

    if (next) {
      next.addEventListener("click", function (event) {
        event.preventDefault();
        if (!answers[stepIndex]) return;
        if (answers[stepIndex] === "no") {
          finish("tbd");
          return;
        }

        if (stepIndex >= steps.length - 1) {
          finish(resultKey());
          return;
        }

        showStep(stepIndex + 1);
      });
    }

    if (back) {
      back.addEventListener("click", function (event) {
        event.preventDefault();
        if (quiz.classList.contains("is-complete")) {
          clearResults();
          showStep(stepIndex);
          return;
        }
        if (stepIndex > 0) {
          showStep(stepIndex - 1);
        }
      });
    }
  });

  (function initInteriorFaq() {
    const page = document.querySelector("[data-faq-page]");
    if (!page) return;

    const nav = document.querySelector("[data-faq-nav]");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function setExpanded(details) {
      const summary = details.querySelector("summary");
      if (summary) {
        summary.setAttribute("aria-expanded", details.open ? "true" : "false");
      }
    }

    page.querySelectorAll("[data-accordion]").forEach(function (details, index) {
      const summary = details.querySelector("summary");
      const panel = details.querySelector(".accordion__panel");
      if (!summary || !panel) return;

      if (!panel.id) {
        panel.id = "faq-panel-" + String(index + 1);
      }
      summary.setAttribute("aria-controls", panel.id);
      setExpanded(details);

      details.addEventListener("toggle", function () {
        setExpanded(details);
      });

      if (reduceMotion || !panel.animate) {
        return;
      }

      let animating = false;
      summary.addEventListener("click", function (event) {
        event.preventDefault();
        if (animating) return;
        if (details.open) {
          collapse(details, panel, function () {
            animating = false;
          });
        } else {
          expand(details, panel, function () {
            animating = false;
          });
        }
        animating = true;
      });
    });

    function expand(details, panel, done) {
      details.open = true;
      setExpanded(details);
      const end = panel.scrollHeight;
      details.classList.add("is-animating");
      const animation = panel.animate(
        [{ height: "0px" }, { height: end + "px" }],
        { duration: 280, easing: "ease" }
      );
      animation.onfinish = function () {
        panel.style.height = "";
        details.classList.remove("is-animating");
        if (done) done();
      };
      animation.oncancel = function () {
        panel.style.height = "";
        details.classList.remove("is-animating");
        if (done) done();
      };
    }

    function collapse(details, panel, done) {
      const start = panel.scrollHeight;
      details.classList.add("is-animating");
      const animation = panel.animate(
        [{ height: start + "px" }, { height: "0px" }],
        { duration: 280, easing: "ease" }
      );
      animation.onfinish = function () {
        details.open = false;
        setExpanded(details);
        panel.style.height = "";
        details.classList.remove("is-animating");
        if (done) done();
      };
      animation.oncancel = function () {
        details.classList.remove("is-animating");
        if (done) done();
      };
    }

    if (!nav) return;

    const links = Array.prototype.slice.call(nav.querySelectorAll("a[href^='#']"));
    const sections = links
      .map(function (link) {
        const id = link.getAttribute("href").slice(1);
        return document.getElementById(id);
      })
      .filter(Boolean);

    function setActive(id) {
      links.forEach(function (link) {
        const on = link.getAttribute("href") === "#" + id;
        link.classList.toggle("is-active", on);
        if (on) {
          link.setAttribute("aria-current", "location");
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    if (sections[0]) {
      setActive(sections[0].id);
    }

    if ("IntersectionObserver" in window && sections.length) {
      const observed = new Map();
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            observed.set(entry.target.id, entry);
          });
          let current = sections[0] && sections[0].id;
          let bestRatio = 0;
          observed.forEach(function (entry, id) {
            if (entry.isIntersecting && entry.intersectionRatio >= bestRatio) {
              bestRatio = entry.intersectionRatio;
              current = id;
            }
          });
          if (current) setActive(current);
        },
        { rootMargin: "-20% 0px -55% 0px", threshold: [0, 0.15, 0.4, 0.75, 1] }
      );
      sections.forEach(function (section) {
        observer.observe(section);
      });
    }

    links.forEach(function (link) {
      link.addEventListener("click", function () {
        const id = link.getAttribute("href").slice(1);
        if (id) setActive(id);
      });
    });
  })();
})();
